
import { TextFieldHelper } from "@goodgamestudios/core";
import { TextField } from "@goodgamestudios/createjs-utilities";
import { TextFieldAutoSize } from "@goodgamestudios/createjs-utilities";
import { Poker2Model } from "../../../model/Poker2Model";
import { TweenMaxGroupHelper } from "../../helper/TweenMaxGroupHelper";

import { NumberStringHelper } from "../../../helper/NumberStringHelper";

import { Back } from "../../../../../../fl/motion/easing/Back";

import MovieClip = createjs.MovieClip;
import Event = createjs.Event;
import { TweenMaxGroup } from "../../helper/TweenMaxGroup";

export class ScoreCounter {
    private _displayScore: number = 0;
    private _totalScore: number = 0;

    private _targetView: MovieClip;
    private _targetViewInitalX: number = NaN;
    private _txtScore: TextField;
    private _updatingScore: boolean = false;
    private _speed: number = 10;

    /** Fake changes for unit changes **/
    private _digit0: number = 0;

    constructor(target: MovieClip) {
        this._targetView = target;
        this._targetViewInitalX = this._targetView.x;
        this._txtScore = this._targetView.txt_score;
    }

    public update(score: number): void {
        // first set: just set the score
        if (this._totalScore == 0) {
            this.setScore(score);
            return;
        }

        // new score is higher -> add score
        if (score > this._totalScore) {
            this.add(score - this._totalScore);
            return;
        }

        // new score is lower -> subtract score
        if (score < this._totalScore) {
            this.subtract(this._totalScore - score);
        }
    }

    public setScore(score: number): void {
        this._totalScore = this._displayScore = score;
        this.updateScoreDisplay();
    }

    public add(amount: number): void {
        this._totalScore += amount;

        this._speed = Math.round((this._totalScore - this._displayScore) / 100);

        this._digit0 = 0;
        if (!this._updatingScore) {
            this._updatingScore = true;
            this._targetView.addEventListener(Event.ENTER_FRAME, this.bindFunction(this.addScore), false, 0, true);
        }
    }

    public subtract(amount: number): void {
        this._totalScore -= amount;

        this._speed = Math.round((this._displayScore - this._totalScore) / 100);

        this._digit0 = 0;
        if (!this._updatingScore) {
            this._updatingScore = true;
            this._targetView.addEventListener(Event.ENTER_FRAME, this.bindFunction(this.subtractScore), false, 0, true);
        }
    }

    private addScore(event: Event): void {
        this._digit0++;

        this._displayScore += this._speed + this._digit0;

        // make sure the display score is not higher than the actual score
        if (this._displayScore > this._totalScore) {
            this._displayScore = this._totalScore;
        }

        // update score view
        this.updateScoreDisplay();

        // if the display score is equal to the total score remove the enterframe event
        if (this._totalScore == this._displayScore) {
            this._updatingScore = false;
            this._targetView.removeEventListener(Event.ENTER_FRAME, this.bindFunction(this.addScore));

            this.scaleText();
        }
    }

    private subtractScore(event: Event): void {
        this._digit0++;

        this._displayScore -= this._speed + this._digit0;

        // make sure the display score is not higher than the actual score
        if (this._displayScore < this._totalScore) {
            this._displayScore = this._totalScore;
        }

        // update score view
        this.updateScoreDisplay();

        // if the display score is equal to the total score remove the enterframe event
        if (this._totalScore == this._displayScore) {
            this._updatingScore = false;
            this._targetView.removeEventListener(Event.ENTER_FRAME, this.bindFunction(this.subtractScore));
        }
    }

    private updateScoreDisplay(): void {
        // cast displayScore as a String
        var scoreStr: string = String(this._displayScore);

        // update text
        TextFieldHelper.changeTextFromatSizeByTextWidth(12, this._txtScore, NumberStringHelper.groupString(this._displayScore, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData)));
    }

    private scaleText(): void {
        // center text
        var preX: number = this._txtScore.x;
        this._txtScore.autoSize = TextFieldAutoSize.LEFT;
        this._txtScore.x = -this._txtScore.textWidth * 0.5;

        // update text container view position
        var diffX: number = preX - this._txtScore.x;
        var newTargetViewX: number = this._targetViewInitalX + diffX;
        this._targetView.x = newTargetViewX;
        this._targetViewInitalX = newTargetViewX;

        // scale text
        var _twg_scaleText: TweenMaxGroup = new TweenMaxGroup();
        _twg_scaleText.to(this._targetView, 0.5, { scaleX: 1.3, scaleY: 1.3, ease: Back.easeIn, onComplete: this.bindFunction(TweenMaxGroupHelper.disposeTweenMaxGroupInstance), onCompleteParams: [_twg_scaleText] });
        _twg_scaleText.play();

        var _twg_scaleText2: TweenMaxGroup = new TweenMaxGroup();
        _twg_scaleText2.to(this._targetView, 0.5, { scaleX: 1.0, scaleY: 1.0, ease: Back.easeOut, onComplete: this.bindFunction(TweenMaxGroupHelper.disposeTweenMaxGroupInstance), onCompleteParams: [_twg_scaleText2] });
        _twg_scaleText2.play();
    }
}

import { Poker2LayoutManager } from "../../Poker2LayoutManager";
